import React, { Suspense } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter, useRoutes } from 'react-router-dom';
import { theme } from './theme/theme';
import Layout from './components/layout/Layout';
import { routes } from './routes/routes';
import { LinearProgress, GlobalStyles } from '@mui/material';
import ScrollToTop from './components/layout/ScrollToTop';

// Import Google Fonts
const WebFont = document.createElement('link');
WebFont.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';
WebFont.rel = 'stylesheet';
document.head.appendChild(WebFont);

const globalStyles = {
  '*': {
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
    maxWidth: '100%',
  },
  html: {
    width: '100%',
    height: '100%',
    WebkitOverflowScrolling: 'touch',
    overflowX: 'hidden',
    scrollBehavior: 'smooth',
  },
  body: {
    width: '100%',
    height: '100%',
    overflowX: 'hidden',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  },
  '#root': {
    width: '100%',
    height: '100%',
    overflowX: 'hidden',
  },
  // Ensure all images and media are responsive
  'img, video, iframe': {
    maxWidth: '100%',
    height: 'auto',
  },
  // Ensure all containers respect viewport width
  '.MuiContainer-root': {
    maxWidth: '100% !important',
    overflowX: 'hidden',
    padding: {
      xs: '0 16px',
      sm: '0 24px',
    },
  },
  // Ensure typography doesn't overflow
  '.MuiTypography-root': {
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  },
};

const AppRoutes = () => {
  const element = useRoutes(routes);
  
  return (
    <Suspense fallback={<LinearProgress />}>
      {element}
    </Suspense>
  );
};

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={globalStyles} />
      <Suspense fallback={<LinearProgress />}>
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <AppRoutes />
          </Layout>
        </BrowserRouter>
      </Suspense>
    </ThemeProvider>
  );
};

export default App;
